<template>
  <div class="measurement-result-list-table">
    <div class="table-header">
      <div
        v-if="useCheckbox"
        class="cell"
        data-test="cell checkbox"
        :style="cellStyles.checkbox"
      />
      <div class="cell" data-test="cell date-time" :style="cellStyles.dateTime">
        <span>検査日時</span>
      </div>
      <div class="cell" data-test="cell category" :style="cellStyles.category">
        <span>検査名</span>
      </div>
      <div
        class="cell"
        data-test="cell instrument"
        :style="cellStyles.instrument"
      >
        <span>検査機器</span>
      </div>
    </div>
    <dynamic-scroller
      class="table-body"
      :items="measurementResults"
      :min-item-size="minItemSize"
    >
      <template v-slot="{ item, index, active }">
        <dynamic-scroller-item
          :item="item"
          :active="active"
          :data-index="index"
        >
          <measurement-result-list-table-row
            data-test="measurement-result-list-table-row"
            :cell-styles="cellStyles"
            :checkbox-description="checkboxDescription"
            :checkbox-status="findCheckboxStatus(item.id)"
            :index="index"
            :is-check-limit="isCheckLimit"
            :measurement-result="item"
            :use-checkbox="useCheckbox"
            @check="$emit('check', $event)"
            @click="$emit('click', $event)"
          />
        </dynamic-scroller-item>
      </template>
    </dynamic-scroller>
  </div>
</template>

<script>
import MeasurementResultListTableRow from '@/components/parts/molecules/MeasurementResultListTableRow'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'

export default {
  name: 'MeasurementResultListTable',

  components: {
    DynamicScroller,
    DynamicScrollerItem,
    MeasurementResultListTableRow
  },

  props: {
    checkboxDescription: { type: String, default: '' },
    checkboxStatuses: { type: Array, default: () => [] },
    isCheckLimit: { type: Boolean, default: false },
    measurementResults: { type: Array, default: () => [] },
    useCheckbox: { type: Boolean, default: false }
  },

  data() {
    return {
      minItemSize: 55 // minItemSizeを設定しないとエラーになるため設定。各アイテムの最小サイズの高さの設定。MeasurementResultListTableRow.vueのmin-height: 55px;の縦の最低幅を設定
    }
  },

  computed: {
    cellStyles() {
      const checkboxStyle = this.useCheckbox ? { width: '40px' } : {}
      const baseStyles = {
        dateTime: { width: '240px', fontFeatureSettings: "'palt'" },
        category: { flex: 1, minWidth: '180px' },
        instrument: { flex: 2 }
      }
      return { checkbox: checkboxStyle, ...baseStyles }
    }
  },

  methods: {
    findCheckboxStatus(measurementResultId) {
      return this.checkboxStatuses.find(
        v => v.measurementResultId === measurementResultId
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.measurement-result-list-table {
  font-size: 15px;
  > .table-header {
    box-sizing: border-box;
    display: flex;
    height: 40px;
    border: 1px solid #{$light-grey};
    background-color: #{$pale};
    padding-right: 17px; //table-body内の値と縦の位置を揃えるため、スクロールバーのwidth分スペースを空ける
    > .cell {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }
    > .cell ~ .cell {
      border-left: 1px solid #{$skin};
    }
  }
  > .table-body {
    box-sizing: border-box;
    overflow-y: scroll;
    overflow-x: hidden;
    border: solid #{$light-grey};
    border-width: 0px 1px 1px 1px;
  }
}
</style>
